import styled from 'styled-components';
import * as antd from 'antd';

export const PaymentButton = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 background:
  linear-gradient(#fff, #fff) padding-box,
  linear-gradient(
    42.69deg,
    #fff33b -5.54%,
    #fee72e -1.35%,
    #fed51b 6.72%,
    #fdca10 15%,
    #fdc70c 23.9%,
    #f3903f 64.56%,
    #ed683c 87.51%,
    #e93e3a 99.24%
   )
   border-box;
 color: #313149;
 width: 300px;
 font-size: 18px;
 line-height: 18px;
 position: relative;
 z-index: 10001;
`;

export const PaymentButtonCard = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 color: white;
 width: 350px;
 font-size: 18px;
 line-height: 18px;
 position: relative;
 z-index: 10001;
 margin-top: 10px;
 border: none;
 cursor: pointer;
`;

export const PaymentButtonSbp = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 color: white;
 width: 300px;
 font-size: 18px;
 line-height: 18px;
 position: relative;
 z-index: 10001;
 margin-top: 10px;
 border: none;
`;

export const PaymentButtonRuble = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 color: white;
 width: 300px;
 font-size: 18px;
 line-height: 18px;
 position: relative;
 z-index: 10001;
 margin-top: 10px;
 border-radius: 0;
`;

export const SumPayBlock = styled.div`
 display: flex;
 justify-content: flex-end;
 align-items: center;
 margin-top: 45px;
 position: relative;
 z-index: 10;
`;

export const Description = styled.span`
 margin-right: 20px;
 font-size: 16px;
`;
